'use client';
import React, { useState } from 'react';
import { Plus, Edit3, Check } from 'lucide-react';

export default function EmailAccountsManagers() {
  const [showForm, setShowForm] = useState(false);
  const [accounts, setAccounts] = useState([
    { email: 'test@mail.com', displayName: 'Store name', isDefault: true },
  ]);
  const [formData, setFormData] = useState({
    email: '',
    displayName: '',
    host: '',
    port: 25,
    ssl: false,
    maxEmails: 50,
    authMethod: 'No authentication',
  });

  const authOptions = [
    'No authentication',
    'NTLM (the default network credentials)',
    'Login/Password',
    'Google (OAuth2)',
    'Microsoft (OAuth2)',
  ];

  const handleSave = () => {
    setAccounts([...accounts, formData]);
    setFormData({
      email: '',
      displayName: '',
      host: '',
      port: 25,
      ssl: false,
      maxEmails: 50,
      authMethod: 'No authentication',
    });
    setShowForm(false);
  };

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-gray-800">Email Accounts</h2>
        <button
          onClick={() => setShowForm(true)}
          className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
        >
          <Plus size={18} /> Add new
        </button>
      </div>

      <div className="overflow-x-auto bg-white rounded-lg shadow">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-100 border-b">
            <tr>
              <th className="px-4 py-2 text-left">Email address</th>
              <th className="px-4 py-2 text-left">Email display name</th>
              <th className="px-4 py-2 text-left">Is default email account</th>
              <th className="px-4 py-2 text-left">Mark as default email account</th>
              <th className="px-4 py-2 text-left">Edit</th>
            </tr>
          </thead>
          <tbody>
            {accounts.map((acc, i) => (
              <tr key={i} className="border-b hover:bg-gray-50">
                <td className="px-4 py-2">{acc.email}</td>
                <td className="px-4 py-2">{acc.displayName}</td>
                <td className="px-4 py-2 text-center">
                  {acc.isDefault && <Check className="text-blue-600 mx-auto" size={18} />}
                </td>
                <td className="px-4 py-2">
                  <button className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600 text-xs">
                    Mark as default
                  </button>
                </td>
                <td className="px-4 py-2">
                  <button className="flex items-center gap-1 bg-gray-100 px-3 py-1 rounded hover:bg-gray-200">
                    <Edit3 size={14} /> Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Add New Email Form Modal */}
      {showForm && (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-2xl relative">
            <h3 className="text-xl font-semibold mb-4">Add a new email account</h3>

            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">Email address *</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full border rounded px-3 py-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Email display name *</label>
                <input
                  type="text"
                  value={formData.displayName}
                  onChange={(e) => setFormData({ ...formData, displayName: e.target.value })}
                  className="w-full border rounded px-3 py-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Host</label>
                <input
                  type="text"
                  value={formData.host}
                  onChange={(e) => setFormData({ ...formData, host: e.target.value })}
                  className="w-full border rounded px-3 py-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Port</label>
                <input
                  type="number"
                  value={formData.port}
                  onChange={(e) => setFormData({ ...formData, port: e.target.value })}
                  className="w-full border rounded px-3 py-2"
                />
              </div>

              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={formData.ssl}
                  onChange={(e) => setFormData({ ...formData, ssl: e.target.checked })}
                />
                <label className="text-sm font-medium">SSL</label>
              </div>

              <div>
                <label className="block text-sm font-medium mb-1">Max number of emails</label>
                <input
                  type="number"
                  value={formData.maxEmails}
                  onChange={(e) => setFormData({ ...formData, maxEmails: e.target.value })}
                  className="w-full border rounded px-3 py-2"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-1">Authentication method</label>
                <select
                  value={formData.authMethod}
                  onChange={(e) => setFormData({ ...formData, authMethod: e.target.value })}
                  className="w-full border rounded px-3 py-2"
                >
                  {authOptions.map((opt, i) => (
                    <option key={i}>{opt}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="flex justify-end mt-6 gap-3">
              <button
                onClick={() => setShowForm(false)}
                className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Save
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Save and Continue Edit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
